// extracted by mini-css-extract-plugin
export default {"question_right":"AfterGameEnd_question_right__NqSLQ","skip_btn":"AfterGameEnd_skip_btn__IpW4a"};